import React from 'react';
import styled from 'styled-components';
import { strings } from '/imports/strings';
import { css } from '/imports/ui/css';
import { Button } from '/imports/ui/Button';
import { Modal, ModalStyled } from '/imports/ui/Modal';
import { toastOnError } from '/imports/ui/utils';
import { fileHref } from '/imports/api/files';
import { ProjectManagementProjectInvoice, projectManagementDecideInvoice } from '/imports/api/projectManagement';

const ReviewModalStyled = styled(ModalStyled)`
  .modal-window { width: 58rem; max-width: 100%; }
`;

/** Super-user invoice review: shows the embedded file (usually a PDF) with Approve / Reject. Reject
 *  soft-deletes the invoice (active:false); approve stamps approvedBy/approvedAt. Shared by the project
 *  Budget tab and the cross-project Invoices page. */
export const ProjectManagementInvoiceReviewModal = (props: { invoice: ProjectManagementProjectInvoice; onClose: () => void }) => {
  const { invoice, onClose } = props;
  const decide = (decision: 'approve' | 'reject') => toastOnError(async () => {
    await projectManagementDecideInvoice.call({ _id: invoice._id, decision });
    onClose();
  })();
  return (
    <Modal styled={ReviewModalStyled} title={`${strings.ReviewInvoice()} — ${invoice.label}`} onClose={onClose}>
      {
        invoice.file
          // #navpanes=0 tells the browser PDF viewer (Chrome/Edge) to hide the left thumbnails/bookmarks pane.
          ? <iframe aria-label={invoice.label} src={`${fileHref(invoice.file)}#navpanes=0`} style={{ width: '100%', height: '70vh', border: `1px solid ${css.grey6}`, borderRadius: '4px' }} />
          : <div className="meta-row">{strings.NoInvoices()}</div>
      }
      <div className="modal-buttons">
        <Button className="secondary" onClick={() => decide('reject')}>{strings.Reject()}</Button>
        <Button className="primary" onClick={() => decide('approve')}>{strings.Approve()}</Button>
      </div>
    </Modal>
  );
};
